import React from 'react'
import { slugs } from '@/constants/slugs'
import { useLegacyEffect } from '@/molecules/utils'
import { contentfulFaqLocations, useProjectFaqs } from '@/services/FaqService'
import { LinkViewModel } from '@/services/RenderService'
import { useSafeTrack } from '@/utils/analytics'
import { FaqSection } from '../LandingView/FaqSection'
import { AdditionalMusicVideosSection } from './AdditionalMusicVideosSection'
import { AlbumSection } from './AlbumSection'
import { EmailCaptureSection } from './EmailCaptureSection'
import { FeaturedSection } from './FeaturedSection'
import { FollowSection } from './FollowSection'
import { HeroSection } from './HeroSection'
import { MusicMusicalsSection } from './MusicAndMusicalsSection'
import { MusicVideoSection } from './MusicVideoSection'
import { PlaylistSection } from './PlaylistSection'
import { AdditionalMusicVideo, HeroImages, MusicVideo, SeriesMusical } from './types'

interface MusicViewProps {
  locale: string
  preview: boolean
  heroImages: HeroImages
  musicVideos: MusicVideo[]
  soundtracks: LinkViewModel[]
  seriesMusicals: SeriesMusical[]
  additionalMusicVideos: AdditionalMusicVideo[]
}

export const MusicView: React.FC<MusicViewProps> = ({
  locale,
  preview,
  heroImages,
  musicVideos,
  soundtracks,
  seriesMusicals,
  additionalMusicVideos,
}) => {
  const track = useSafeTrack()
  const { faqs, loadingProjectFaqs } = useProjectFaqs({
    locale,
    preview,
    projectSlug: slugs.angelStudios,
    location: contentfulFaqLocations.home,
  })

  useLegacyEffect(() => {
    track('Music Page Viewed')
  }, [track])

  return (
    <main className="h-full w-full bg-core-gray-950 text-white">
      <HeroSection heroImages={heroImages} />
      <FollowSection />
      <MusicVideoSection musicVideos={musicVideos} />
      <FeaturedSection slug={slugs.david} />
      <AlbumSection soundtracks={soundtracks} />
      <PlaylistSection />
      <AdditionalMusicVideosSection additionalMusicVideos={additionalMusicVideos} />
      <MusicMusicalsSection seriesMusicals={seriesMusicals} />
      <FeaturedSection slug={slugs.aWeekAwaySeries} />
      <EmailCaptureSection />
      {!loadingProjectFaqs && (
        <div className="mt-20 lg:mt-0">
          <FaqSection faqs={faqs} />
        </div>
      )}
    </main>
  )
}
